import {FC, SVGProps} from 'react';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from 'app/router/routes';
import {ALFA_PERSONAL_DATA_CONSENT_MESSAGE, REGISTRATION_EDIT_STATUSES_SEARCH} from 'features/registration';
import styles from '../IdentityVerificationRejectedBanner/IdentityVerificationRejectedBanner.module.css';

const WarningTriangleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path d="M32 8L58 54H6L32 8Z" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
		<path d="M32 26V38" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
		<circle cx="32" cy="44.5" r="1.75" fill="currentColor" />
	</svg>
);

export const AlfaPersonalDataConsentBanner: FC = () => {
	const navigate = useNavigate();

	return (
		<section className={styles.banner} aria-live="polite">
			<div className={styles.top}>
				<div className={styles.text}>
					<h2 className={styles.title}>{ALFA_PERSONAL_DATA_CONSENT_MESSAGE}</h2>
				</div>
				<span className={styles.iconWrap}>
					<WarningTriangleIcon className={styles.icon} />
				</span>
			</div>
			<button
				type="button"
				className={styles.button}
				onClick={() => navigate(`${ROUTES.registration}?${REGISTRATION_EDIT_STATUSES_SEARCH}`)}
			>
				Подтвердить
			</button>
		</section>
	);
};
